import React from "react";
import moment from "moment-timezone";
import { Row, Col, Card } from "@themesberg/react-bootstrap";

export default () => {
  const currentYear = moment().get("year");

  return (
    <footer className="footer section py-5 px-5">
      <Row>
        <Col xs={12} lg={6} className="mb-4 mb-lg-0">
          <p className="mb-0 text-center text-xl-left">
            {`${currentYear} `} © (주)유라스텍 All Rights Reserved.
          </p>
        </Col>
      </Row>
    </footer>
  );
};
